var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonicMdArrowDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-arrow-dropdown",
    "data-name": "Icon ionic-md-arrow-dropdown",
    d: "M9,13.5l5,5,5-5Z",
    transform: "translate(-9 -13.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicMdArrowDropdown);
export default __webpack_public_path__ + "static/media/ionic-md-arrow-dropdown.a17a6b43a9a7e0dde25126be1b65713c.svg";
export { ForwardRef as ReactComponent };